import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import HandleChange from '../../../../Helpers/HandleChange';
import { CREATE_LAYOUT_MODEL } from '../Model/Model';

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Layouts modal: the form of the Create Layout tab, which owns the footer buttons.
 */
const LayoutsModalApp = ({ onCreate }) => {
    const { t } = useTranslation();
    const [item, setItem] = useState(CREATE_LAYOUT_MODEL.clear());
    const [emptyFields, setEmptyFields] = useState(false);
    const { handleChange } = HandleChange({ model: item, setModel: setItem });

    const handleSelectType = (typeId) => setItem((prev) => ({ ...prev, typeId }));

    const handleConfirm = () => {
        if (!CREATE_LAYOUT_MODEL.isValid(item)) {
            setEmptyFields(true);
            return;
        }
        onCreate(item);
    };

    return {
        t,
        item,
        emptyFields,
        handleChange,
        handleSelectType,
        handleConfirm
    };
};

export default LayoutsModalApp;
